module.exports = __webpack_public_path__ + "static/img/case-2zuozhanwuzi.c534f63f.jpg";